'use client'

import { useEffect } from 'react'
import { VendorScriptEventController } from './VendorScriptEventController'
import { getTrackingService } from '../tracking/TrackingInstance'

export function GlobalInitializer() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const controller = VendorScriptEventController.getInstance()

    controller.on('GTM', async () => {
      await getTrackingService().enable()
    })

    return () => {
      controller.off('GTM')
    }
  }, [])
  return null
}
